import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectVulnDetail
} from 'store/Manage/selectors';
import debounce from 'lodash/debounce';
import { updateVuln } from 'store/Manage/actions';
import CopyLink from './components/CopyLink';
import CopyApiLink from './components/CopyApiLink';
import { Wrapper, InputTitle, IconVulnerability } from './styled';
import { selectReadOnly } from 'store/Faraday/selectors';

const Title = () => {
  const dispatch = useDispatch();
  const vulnDetail = useSelector(selectVulnDetail);
  const [vulnName, setVulnName] = useState(vulnDetail.name);
  const readOnly = useSelector(selectReadOnly);

  useEffect(() => {
    setVulnName(vulnDetail.name);
  }, [vulnDetail]);

  const updateName = useRef(debounce((name, vuln) => {
    if (name) {
      dispatch(updateVuln(vuln, 'name', name));
    }
  }, 1000));

  const handleChange = (e) => {
    const name = e.target.value;
    setVulnName(name);
    updateName.current(name, vulnDetail);
  };

  return (
    <Wrapper>
      <IconVulnerability />
      <InputTitle value={ vulnName } onChange={ handleChange } disabled={ readOnly } />
      <CopyLink />
      <CopyApiLink />
    </Wrapper>
  );
};

export default Title;
